export default __webpack_public_path__ + "static/media/November2022.074294fb.png";